import { getScrollbarWidth } from '../utils/scroll';
export class ScrollLock {
    constructor() {
        this.fixedBlockElements = Array.from(document.querySelectorAll('[data-scroll-lock-block]'));
    }
    static getBodyScrollTop() {
        return (window.scrollY
            || (document.documentElement && document.documentElement.scrollTop)
            || (document.body && document.body.scrollTop));
    }
    disableScrolling() {
        const scrollTop = +(document.body.getAttribute('data-scroll') || 0) || ScrollLock.getBodyScrollTop();
        document.body.setAttribute('data-scroll', String(scrollTop));
        const scrollbarWidth = getScrollbarWidth();
        if (scrollbarWidth > 0) {
            document.body.style.paddingRight = `${scrollbarWidth}px`;
            this.fixedBlockElements.forEach((block) => {
                if (block)
                    block.style.paddingRight = `${scrollbarWidth}px`;
            });
        }
        Object.assign(document.body.style, {
            overflow: 'hidden', touchAction: 'none', top: `-${scrollTop}px`, scrollBehavior: 'auto',
        });
    }
    enableScrolling() {
        Object.assign(document.body.style, {
            overflow: '', touchAction: '', paddingRight: '', top: '', scrollBehavior: '',
        });
        this.fixedBlockElements.forEach((block) => {
            if (block)
                block.style.paddingRight = '';
        });
        const scrollTop = +(document.body.getAttribute('data-scroll') || 0);
        if (scrollTop) {
            window.scrollTo(0, scrollTop);
        }
        document.body.removeAttribute('data-scroll');
    }
}
document.documentElement.style.setProperty('--scrollbar-width', `${getScrollbarWidth()}px`);
window.scrollLock = new ScrollLock();
